import { useContext, useState } from 'react';
import { ProductoData } from '../../model/ProductoData';
import { useUserStatus } from '../../config/authentication/useUserStatus';
import { LoginDialogContext } from '../header/login/LoginDialogContext';
import { UserData } from '../../model/UserData';

export type OpenCanjeFn = (currentUserData?: UserData, product?: ProductoData) => void;

export function useCanjeActivation() {
  const [showCanje, setshowCanje] = useState<boolean>(false);
  const [selectedProduct, setSelectedProduct] = useState<ProductoData>();
  const { loginData, checkLogin } = useUserStatus();
  const loginDialogState = useContext(LoginDialogContext);

  const openCanje: OpenCanjeFn = (currentUserData, product) => {
    /** Control de puntos suficientes */
    if (currentUserData?.points != null && product?.puntos && currentUserData.points >= product.puntos) {
      setSelectedProduct(product);
      setshowCanje(true);
    }
  };

  function closeCanje() {
    setshowCanje(false);
    setSelectedProduct(undefined);
  }

  function onClickCanje(currentProduct?: ProductoData) {
    if (checkLogin()) openCanje(loginData?.user, currentProduct);
    /**Si no está autenticado, primero se abre modal de login.*/ else
      loginDialogState?.showDialog((currentUserData?: UserData) => openCanje(currentUserData, currentProduct));
  }

  return { showCanje, onClickCanje, closeCanje, selectedProduct, openCanje } as const;
}
